import { ComponentPropsWithoutRef } from 'react';
import { Typography } from '../../../ui';

export function Paragraph(props: ComponentPropsWithoutRef<'p'>) {
  const { children, ...rest } = props;

  return (
    <Typography
      as="p"
      variant="body-s"
      weight="regular"
      className="text-grayscale500"
      {...rest}
    >
      {children}
    </Typography>
  );
}
